const InfoCircleSvg = ({
  height = 18,
  width = 18,
  // The circle's path spans exactly 0-17.5 in both axes, not 0-18 - was leaving 0.5
  // units of blank padding on the bottom/right only, sub-pixel but genuinely off-center.
  viewBox = '0 0 17.5 17.5',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 0C13.5826 0 17.5 3.91737 17.5 8.75C17.5 13.5826 13.5826 17.5 8.75 17.5C3.91737 17.5 0 13.5826 0 8.75C0 3.91737 3.91737 0 8.75 0ZM8.75 12.25C8.51793 12.25 8.29537 12.3422 8.13128 12.5063C7.96719 12.6704 7.875 12.8929 7.875 13.125C7.875 13.3571 7.96719 13.5796 8.13128 13.7437C8.29537 13.9078 8.51793 14 8.75 14C8.98206 14 9.20462 13.9078 9.36872 13.7437C9.53281 13.5796 9.625 13.3571 9.625 13.125C9.625 12.8929 9.53281 12.6704 9.36872 12.5063C9.20462 12.3422 8.98206 12.25 8.75 12.25ZM8.75 3.9375C7.90877 3.9375 7.10199 4.27168 6.50714 4.86652C5.9123 5.46136 5.57812 6.26814 5.57812 7.10937C5.57812 7.34144 5.67031 7.564 5.83441 7.72809C5.9985 7.89219 6.22106 7.98437 6.45312 7.98437C6.68519 7.98437 6.90775 7.89219 7.07184 7.72809C7.23594 7.564 7.32812 7.34144 7.32812 7.10937C7.32841 6.85128 7.39895 6.59813 7.53216 6.37708C7.66537 6.15602 7.85624 5.97539 8.0843 5.85455C8.31236 5.73372 8.56901 5.67724 8.82673 5.69117C9.08444 5.70509 9.33351 5.78891 9.54722 5.93361C9.76093 6.07832 9.93122 6.27847 10.0398 6.5126C10.1484 6.74672 10.1913 7.006 10.1638 7.26262C10.1362 7.51924 10.0394 7.76353 9.88358 7.96929C9.72778 8.17506 9.51891 8.33453 9.27937 8.43062C8.68787 8.66687 7.875 9.27237 7.875 10.2812V10.5C7.875 10.7321 7.96719 10.9546 8.13128 11.1187C8.29537 11.2828 8.51793 11.375 8.75 11.375C8.98206 11.375 9.20462 11.2828 9.36872 11.1187C9.53281 10.9546 9.625 10.7321 9.625 10.5C9.625 10.2865 9.66875 10.1797 9.85337 10.0887L9.9295 10.0537C10.6127 9.7789 11.179 9.27496 11.5314 8.6283C11.8837 7.98165 12.0002 7.23256 11.8607 6.50946C11.7213 5.78636 11.3346 5.13429 10.7671 4.66504C10.1995 4.19578 9.48642 3.93857 8.75 3.9375Z"
        fill="#2A99B7"
      />
    </svg>
  );
};

export default InfoCircleSvg;
